import { useCallback, useEffect, useState } from 'react';
import { AxiosError } from 'axios';
import { useSnackbar } from 'notistack';
import { getRealEstateEventTypes } from '../api';
import { IRealEstateEventType } from '../interfaces';

function useLoadRealEstateEventTypes() {
  const { enqueueSnackbar } = useSnackbar();

  const [realEstateEventTypes, setRealEstateEventTypes] = useState<IRealEstateEventType[]>([]);
  const [state, setState] = useState<{ loading: boolean; error: string | null }>({ loading: false, error: null });

  const fetchRealEstateEventTypes = useCallback(async () => {
    try {
      setState({ loading: true, error: null });

      setRealEstateEventTypes(await getRealEstateEventTypes());
    } catch (error) {
      const message = (error as AxiosError).response?.data.message;

      setState({ loading: false, error: message });
      enqueueSnackbar(message, { variant: 'error' });
    } finally {
      setState((prevState) => ({ ...prevState, loading: false }));
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    fetchRealEstateEventTypes();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return { realEstateEventTypes, loadEventTypesState: state, fetchRealEstateEventTypes, setRealEstateEventTypes };
}

export default useLoadRealEstateEventTypes;
